import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";

export enum EXPORT_TYPE {
  SUMMARY_REPORT = "SUMMARY_REPORT",
  LEAVE_REPORT = "LEAVE_REPORT",
  COMPENSATORY_LEAVE_REPORT = "COMPENSATORY_LEAVE_REPORT",
  LATE_EARLY_REPORT = "LATE_EARLY_REPORT",
  CHECK_IN_OUT = "CHECK_IN_OUT",
  TIMEKEEPING_DETAIL = "TIMEKEEPING_DETAIL",
}

interface FormFilterInterface {
  searchText: string;
  departmentLevel1Code: string;
  departmentLevel2Code: string;
  leaveReasonCode: string;
  positionCode: string;
  workingAreaCode: string;
  from: moment.Moment | null;
  to: moment.Moment | null;
  leaveReasonType: string;
}

interface InitialState {
  filterInput: FormFilterInterface;
}

const initialState: InitialState = {
  filterInput: {
    searchText: "",
    departmentLevel1Code: "",
    departmentLevel2Code: "",
    leaveReasonCode: "",
    positionCode: "",
    workingAreaCode: "",
    leaveReasonType: "",
    from: null,
    to: null,
  },
};

const formFilterEmployeeLeaveSlice = createSlice({
  name: "formFilterEmployeeLeave",
  initialState,
  reducers: {
    formFilterEmployeeLeaveUpdate: (state, action) => {
      Object.assign(state.filterInput, action.payload);
    },
    resetFilter: (state) => {
      state.filterInput = {
        ...initialState.filterInput,
      };
    },
    resetForm: (state) => {
      state.filterInput = {
        ...initialState.filterInput,
        from: state.filterInput.from,
        to: state.filterInput.to,
      };
    },
    formFilterEmployeeLeaveReset: () => {
      return { ...initialState };
    },
  },
});

export const {
  formFilterEmployeeLeaveUpdate,
  formFilterEmployeeLeaveReset,
  resetFilter,
  resetForm,
} = formFilterEmployeeLeaveSlice.actions;

export default formFilterEmployeeLeaveSlice.reducer;
